import React, {useState} from "react";
import Header from "./PublikasiPenangananPengaduan/Header";
import KebijakanPengaduanTab from "./PublikasiPenangananPengaduan/KebijakanPengaduanTab";
import TablePengaduan from "./PublikasiPenangananPengaduan/TablePengaduan";

export default function PublikasiPenangananPengaduan(){
    const [active, setActive] = useState("kebijakan");
    const renderContent = () => {
        switch (active) {
            case "publikasi":
                return <TablePengaduan/>;
            default:
                return <KebijakanPengaduanTab/>;
        }
    };
    return (
        <div>
            <div className="my-16 hero-bg-publikasi-pengaduan">
                <Header/>
                <div className="max-w-screen-2xl flex flex-col mx-auto">
                    <div className="container-publikasi-pengaduan tabs-wrapper">
                        <div className="tabs-container">
                            <button
                                className={`tab-btn ${active === "kebijakan" ? "active" : ""}`}
                                onClick={() => setActive("kebijakan")}
                            >
                                Kebijakan Layanan Pengaduan
                            </button>

                            <button
                                className={`tab-btn ${active === "publikasi" ? "active" : ""}`}
                                onClick={() => setActive("publikasi")}
                            >
                                Publikasi Penanganan Pengaduan
                            </button>
                        </div>
                    </div>
                    {renderContent()}
                </div>
            </div>
        </div>
    );
}